import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Card, TextField } from '@mui/material'
import { mainGreen } from '../../utils/color'

export default function UpdateTransferInfo() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken

	const [storeEdit, setStoreEdit] = useState({
		values: {
			bank: '',
			account_name: '',
			account_number: '',
			phone: '',
		},
	})

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...storeEdit.values, [name]: value }

		setStoreEdit({ values: newValue })
	}

	const getStore = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/storeManager/transfer-info/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStoreEdit({
					values: {
						name: response.data.name || '',
						bank: response.data.bank || '',
						account_name: response.data.account_name || '',
						account_number: response.data.account_number || '',
						phone: response.data.phone || '',
					},
				})
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, currentUser.store, navigate, dispatch],
	)

	useEffect(() => {
		getStore()
	}, [getStore])

	const editStore = async function () {
		const bank = storeEdit.values.bank
		const account_name = storeEdit.values.account_name
		const account_number = storeEdit.values.account_number
		const phone = storeEdit.values.phone

		try {
			const response = await axios({
				url: `${DOMAIN}/storeManager/transfer-info/${currentUser.store}`,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: {
					bank,
					account_name,
					account_number,
					phone,
				},
				withCredentials: true,
			})
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
				<Card sx={{ margin: '20px 20px 10px 20px', padding: '10px' }}>
					<TextField
						value={storeEdit.values?.bank}
						margin='normal'
						fullWidth
						label='Ngân hàng'
						name='bank'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.account_name}
						margin='normal'
						fullWidth
						label='Chủ tài khoản'
						name='account_name'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.account_number}
						margin='normal'
						fullWidth
						label='Số tài khoản'
						name='account_number'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.phone}
						margin='normal'
						fullWidth
						label='Số điện thoại'
						name='phone'
						onChange={handleChange}
					/>
					<Box sx={{ mt: 2 }}>
						<Button
							sx={{
								marginLeft: 'auto',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							fullWidth
							size='small'
							variant='contained'
							onClick={() => {
								const confirmEdit = window.confirm('Bạn có chắc muốn cập nhật thông tin cho cửa hàng này?')
								if (confirmEdit) {
									editStore()
								}
							}}>
							Cập nhật
						</Button>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
